import React from 'react';

class Home extends React.Component {
	render() {
		return (
			<div>
				<p>You should really never see this page - sorry if you really wanted too. Click an option above</p>
			</div>
		);
	}
}

export default Home;


/** WEBPACK FOOTER **
 ** ./src/modules/Home.js
 **/